import React, { useEffect, useMemo, useState, useCallback } from 'react';
import {  createLicense, deleteLicense, GetLicensesList, RefrechLicense,changesubscriberLicensefvOrNot, SendLicense,ClearDatabasePOST,GetLicensesListGenereatedTest, DisableSubscription,getExportList, RenwSubscription, updateLicense, SendEmail, SaveIntegraationData,SaveConcurentPlatformsData, SaveAditionalModuleData, SetFVRozliczenie, SendOneMoreTime, createKeyList, GetLicensesListGenereated } from '../api/licenses';
import StatCard from '../components/StatCard';
import Table from '../components/Table';
import Button from '../components/Button';
import Input from '../components/Input';
import Select from '../components/Select';
import Chip from '../components/Chip';
import Alert from '../components/Alert';


import { Dialog, DialogTitle, DialogContent, DialogActions } from '../components/Dialog';
import Snackbar from '../components/Snackbar';
import { format, isPast, parseISO } from 'date-fns';
import { is, pl } from 'date-fns/locale';
import { useAuth } from '../store/auth';
import RowActions from '../components/RowActions';
import SuppliersDialog from '../components/Dialogs/SuppliersDialog';
import { BsCardChecklist,BsKey, BsCheck,BsTrash2,BsLink, BsTable, BsCloudDownload, BsHourglass,BsFillTrash3Fill , BsPatchQuestion , BsShieldCheck, BsCloudUpload, BsCloud, BsNutFill  } from 'react-icons/bs';
import LicensesFVDialog from '../components/Dialogs/LicensesFVDialog';
import { GetRPTData } from '../api/licenses';
import { motion, AnimatePresence } from "framer-motion";
import { useConfirm } from '../components/ConfirmContext';
import { saveAs } from 'file-saver';
import ConcurentPlatformsDialog from '../components/Dialogs/ConcurentPlatformsDialog';
import Tabs from '../components/Tabs';
import TestKeysSpecialLinkDialog from '../components/Dialogs/TestKeysSpeciaLinkDialog';
import { BiLink } from 'react-icons/bi';
import PageHeaderPortal from '../components/PageHeaderPortal';
import AditionalModuleDialog from '../components/Dialogs/AditionalModuleDialog';
import SpyRadarIco from '../components/SpyRadarIco';
import SpyRadarDetailsUser from '../components/Dialogs/SpyRadarDetailsUser';
export default function Licenses() {
  const [options, setOptions] = useState({ licensesList: [], companies: [], users: [] , vendorList: [], integracje: [], needFV: [], rptList: []});
  const [rows, setRows] = useState([]);
    const [rowsTestLicenses, setRowsTestLicenses] = useState([]);

    const [rowsGenerated, setRowsGenerated] = useState([]);
    const [rowsGeneratedTest, setRowsGeneratedTest] = useState([]);
  const [openLink, setOpenLink] = useState(false);
  const [link, setLink] = useState('');
    const [selectedTab, setSelectedTab] = useState("tab1");
  const [showRptTag, setShowRptTag] = useState(false);
  const { requestConfirm } = useConfirm();
  const [loading, setLoading] = useState(true); 
  const [q, setQ] = useState('');
  const [licenseType, setlicenseType] = useState('all');
  const [vendorType, setvendorType] = useState('all'); 
  const [expandRptTag, setExpandRptTag] = useState(false);
  const [licenseIsRuning, setLicenseIsRuning] = useState('all'); 
  const [isActivate, setisActivate] = useState('all'); 
  const [isLicenseSend, setisLicenseSend] = useState('all'); 

  const [fvStatus, setFVStatus] = useState('all'); 
  const { user, logout } = useAuth();

  const [open, setOpen] = useState(false);
  const [OpenGenere, setOpenGenere] = useState(false);
  const [openExport, setopenExport] = useState(false);
  const [openFV, setOpenFV] = useState(false);
  const [openSuppliersDialog, setOpenSuppliersDialog] = useState(false);
    const [openAditionalModuleDialog, setOpenAditionalModuleDialog ] = useState(false);
    const [openConcurentPlatformsDialog, setOpenConcurentPlatformsDialog ] = useState(false);
    const [openCompetitionListDialog, setOpenCompetitionListDialog ] = useState(false);

  const [selectedSuppliers, setSelectedSuppliers] = useState('');
  const [editing, setEditing] = useState(null);
  const [editingKeyGenere, setEditingKeyGenere] = useState(null);
 const [details, setDetails] = useState(null);
  const [form, setForm] = useState({ name: '', email: '', role: 'user' });
    const [formGenere, setFormGenere] = useState({ keyType: '', keyCount: 20 });
    const [formGenereExport, setFormGenereExport] = useState({ exportType: '',exportTypestatus:'' });

  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
   let logedUser = useAuth((state) => state.user);

 const handleSaveSupliersIntegration = useCallback(async (ids) => {
  // Aktualizacja wiersza w tabeli
  setRows((prev) =>
    prev.map((item) =>
      item.id === editing.id ? { ...item, integrationIds: ids } : item
    )
  );



  // Aktualizacja formularza
  setForm((prev) => ({ ...prev, supplierId: ids }));


    const data =await SaveIntegraationData(editing.id, ids);
       setToast({ open: true, message: data.message, severity: data.status });

  setOpenSuppliersDialog(false);
}, [editing]);

const handleSaveAditionalModules = useCallback(async (ids) => {
  // Aktualizacja wiersza w tabeli
  setRows((prev) =>
    prev.map((item) =>
      item.id === editing.id ? { ...item, access_ids: ids } : item
    )
  );
  // Aktualizacja formularza
  setForm((prev) => ({ ...prev, access_ids: ids }));


    const data =await SaveAditionalModuleData(editing.id, ids);
       setToast({ open: true, message: data.message, severity: data.status });

  setOpenAditionalModuleDialog(false);
}, [editing]);
const handleSaveConcurentPlatforms = useCallback(async (ids) => {
  // Aktualizacja wiersza w tabeli
  setRows((prev) =>
    prev.map((item) =>
      item.id === editing.id ? { ...item, concurent_platforms: ids } : item
    )
  );
  // Aktualizacja formularza
  setForm((prev) => ({ ...prev, concurent_platforms: ids }));


    const data =await SaveConcurentPlatformsData(editing.id, ids);
       setToast({ open: true, message: data.message, severity: data.status });

  setOpenConcurentPlatformsDialog(false);
}, [editing]);

const openLinkCallback = useCallback((row) => {
  console.log(row);
  setLink(row.secret_tag+'/'+row.keyHash);
  setOpenLink(true);
}, []);
  const LicenseStatusChip = React.memo(({ date, isNewAcount }) => {
    if (isNewAcount === "1" || isNewAcount === 1) {
      return <Chip color="default" size="small" label="Nie wysłano" />;
    }
    if (!date) return <Chip color="default" size="small" label="Brak daty" />;
    const parsed = new Date(String(date).replace(' ', 'T'));
    const expired = parsed < new Date();
    return expired 
      ? <Chip color="error" size="small" label="Wygasła" /> 
      : <Chip color="success" size="small" label="Aktywna" />;
  });
const FvStatusChip = React.memo(({ counter , testTag, isAddedToFv}) => {
  if(isAddedToFv === "0" || isAddedToFv === 0){
    return <Chip color="amber" size="small" label="Poza systemem" />;
  }
  else{

  

  if(testTag==="10"){
    return <Chip color="special" size="small" label="Nie dotyczy" />;
  }
  else{
  if (counter === "1") {
    return <Chip color="error" size="small" label="Wymagane" />;
  }

  if (counter === "2") {
    return <Chip color="warning" size="small" label="Założone" />;
  }
}
  }

  

  // jeśli counter = 0 lub undefined/null
  return <Chip color="success" size="small" label="Zapłacone" />;
});
  

  useEffect(() => {
    setLoading(true);
  
   Promise.all([
    fetch("https://hs2api.razamit.pl/licensesList").then(res => res.json()),
    fetch("https://hs2api.razamit.pl/vendorsList").then(res => res.json()),
    fetch("https://hs2api.razamit.pl/integrationList").then(res => res.json()),
    fetch("https://hs2api.razamit.pl/aditionalModuleList").then(res => res.json()),
    fetch("https://hs2api.razamit.pl/getsupliersList").then(res => res.json())
])
  .then(([licensesData, vendorsData, integracjeData, aditionalModuleData, supliersList]) => {
    setOptions({
      licensesList: licensesData.licensesList || [],
      vendorList: vendorsData.vendorList || [],
      integracje: integracjeData.integracje || [],
      concurentPlatformsData: supliersList.supliersList || [],
     aditionalModuleData: aditionalModuleData.aditionalModuleData || []
    });
  })
  .catch((err) => console.error("Błąd pobierania danych:", err))
  .finally(() => setLoading(false));
  }, []);

  const fetchRptList = async () => {
  setLoading(true);
  try {
    const data = await GetRPTData();
    //console.log(data);
    setOptions(prevOptions => ({
      ...prevOptions,
      rptList: data || []
    }));

   // console.log('ista');
    // jeśli coś pobrano, pokaż tag
    if (data && data.length > 0) {
     // console.log(data);
      setShowRptTag(true);
    }
  } finally {
    setLoading(false);
  }
};

  useEffect(() => { fetchRptList(); }, []);




  const runCheckRPT = () => {
    fetchRptList();
  };
 const fetchDataLicenseGenerated = async () => {
    setLoading(true);
    try {
      const data = await GetLicensesListGenereated();

    const mapped = data.data.map(item => ({
      dystributor: item.dystributor,
      keyHash: item.keyHash,               
      keyDate: item.keyDate,
      isTest: item.isTest,   
      isExport: item.isExport ,
      secret_tag:item.secret_tag
    }));
      setRowsGenerated(mapped);
    } finally {
      setLoading(false);
    }
  };
 const fetchDataLicenseGeneratedTest = async () => {
    setLoading(true);
    try {
      const data = await GetLicensesList('t');
  const mapped = data.data.map(item => ({
      id: item.subscriber_id,
      name: item.license_name,
      client_email: item.client_email,
      accountManager: item.us_name,
      shop_expireDate: item.shop_expireDate,
      last_login: item.last_login,
      counttofv: item.counttofv,
      login_data: item.login_data,
      shop_name: item.shop_name,
      active: item.active,
      nip: item.nip,
      shop_phone: item.shop_phone,
      licenseId: item.licenseId,
      license_name: item.license_name,
      licDays: item.licDays,
      newAcount: item.newAcount,
      userID: item.UserId,
      vendorId: item.vendorId,
      integrationIds: item.integrationIds,
      CompnyName: item.CompnyName,
      renewals_count: item.renewals_count,
      needFV: item.needFV,
      NoneedFV: item.NoneedFV,
      needFvTagedToExport: item.needFvTagedToExport,
      license_number: item.license_number ?? "-",
      subscriber_id: item.subscriber_id,
      user_want_use: item.user_want_use,
      concurent_platforms: item.concurent_platforms,
      wantBrandly: item.wantBrandly
    
    }));

    setRowsTestLicenses(mapped);
    } finally {
      setLoading(false);
    }
  };

  

 const fetchData = async (filter= "p") => {
  setLoading(true);

  try {
    const data = await GetLicensesList(filter);

    if (!data || data.error) {
      throw new Error(data?.error || "Błąd serwera");
    }

    const mapped = data.data.map(item => ({
      id: item.subscriber_id,
      name: item.license_name,
      client_email: item.client_email,
      accountManager: item.us_name,
      shop_expireDate: item.shop_expireDate,
      last_login: item.last_login,
      login_data: item.login_data,
      shop_name: item.shop_name,
      active: item.active,
      nip: item.nip,
      shop_phone: item.shop_phone,
      licenseId: item.licenseId,
      license_name: item.license_name,
      licDays: item.licDays,
      newAcount: item.newAcount,
      userID: item.UserId,
      vendorId: item.vendorId,
      integrationIds: item.integrationIds,
      CompnyName: item.CompnyName,
      renewals_count: item.renewals_count,
      needFV: item.needFV,
      NoneedFV: item.NoneedFV,
      needFvTagedToExport: item.needFvTagedToExport,
      license_number: item.license_number ?? "-",
      subscriber_id: item.subscriber_id,
      user_want_use: item.user_want_use,
      counttofv: item.counttofv,
      access_ids: item.access_ids,
       concurent_platforms: item.concurent_platforms,
      wantBrandly: item.wantBrandly,
selectedBrandly: item.selectedBrandly,
brandlyTime: item.brandlyTime,
    }));

    setRows(mapped);

  } catch (err) {
    console.error("Fetch error:", err.message);

    // 🔥 Jeśli to błąd tokena → przekieruj na login
    if (err.message.includes("token")) {
      setRows([]); // wyczyść tabelę, żeby nie było crash
      window.location.href = "/login"; // lub Twoja ścieżka
      return;
    }

    // 🔥 inne błędy
   // alert("Wystąpił nieoczekiwany błąd.");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => { fetchData(); }, []);

  const onSendOneMoreTime = useCallback(async (row) => {
    const data = await SendOneMoreTime(row);

    
    setToast({ open: true, message: data.message, severity: data.status });
    fetchData();

  }, []);

 const onEdit = useCallback((row) => {
    setEditing(row);
    setForm({ client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
    setOpen(true);
  }, []);

  const onRefresh = useCallback(async (row) => {
    const data = await RefrechLicense(row);
    setToast({ open: true, message: data.message, severity: data.status });
    if(selectedTab === "p"){
      fetchData();
    }else{
      fetchDataLicenseGeneratedTest();
    }
    

  }, []);
const changesubscriberLicefvOrNot = useCallback(async (row) => {
  const data = await changesubscriberLicensefvOrNot(row);

  setToast({
    open: true,
    message: data.message,
    severity: data.status
  });

  console.log(data);
  if (data.status === "success") {
    console.log(data);
    setRows(prev =>
      prev.map(item =>
        item.id === row.id
          ? { ...item, counttofv: item.counttofv === 1 ? 0 : 1 }
          : item
      )
    );
  }
}, []);


  const renvewSubscription = useCallback(async (row) => {
    const data = await RenwSubscription(row);
    setToast({ open: true, message: data.data.message, severity: data.data.status });


     if (data.data.success) {
      if(selectedTab === "p"){
         setRows((prev) =>
        prev.map((r) =>
          r.id === row.id
            ? { ...r, user_want_use: "1" } 
            : r
        )
      );
      }else{
         setRowsTestLicenses((prev) =>
        prev.map((r) =>
          r.id === row.id
            ? { ...r, user_want_use: "1" } 
            : r
        )
      );
      }
    
    }
  }, []);
  const disableSubscription = useCallback(async (row) => {
    const data = await DisableSubscription(row);
    setToast({ open: true, message: data.data.message, severity: data.data.status });
  if (data.data.success) {
      setRows((prev) =>
        prev.map((r) =>
          r.id === row.id
            ? { ...r, user_want_use: "0" } 
            : r
        )
      );
    }
  }, []);
  const onSendEmail = useCallback(async () => {
    await SendEmail();
  }, []);
  const onEditParserAccess = useCallback((row) => {
    setEditing(row);
    setForm({   supplierId: row.integrationIds, client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
    setOpenSuppliersDialog(true);
  }, []);
  const onEditAdititionalModules = useCallback((row) => {
    setEditing(row);
    setForm({ access_ids: row.access_ids, supplierId: row.integrationIds, client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
    setOpenAditionalModuleDialog(true);
  }, []);

 const onChangeConcurentPlatforms = useCallback((row) => {
    setEditing(row);
    setForm({concurent_platforms: row.concurent_platforms, access_ids: row.access_ids, supplierId: row.integrationIds, client_email: row.client_email, shop_name: row.shop_name, nip: row.nip, shop_phone: row.shop_phone, licenseId: row.licenseId, license_name: row.license_name, licDays: row.licDays , userID:row.userID});
        setOpenConcurentPlatformsDialog(true);

  }, []);
   const detailsConcurentPAnelDIalog = useCallback((row) => {
    console.log(row);
    setDetails(row);
        setOpenCompetitionListDialog(true);

  }, []);
  const onSendLicense = useCallback(async (row) => {
    await SendLicense(row.id);
    setToast({ open: true, message: 'Wysłano licencję do klienta', severity: 'success' });
    fetchData();
  }, []);

  const onAcceptPrzetwarzanie = useCallback(async (row) => {

    await SetFVRozliczenie(row.subscriber_id);
     setRows((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? { ...item, needFvTagedToExport: "0", needFV:"0" } // tylko ten rekord zmieniamy
          : item
      )
    );
   // await AcceptPrzetwarzanie(row.id);
    setToast({ open: true, message: 'Rozliczono klienta', severity: 'success' });
  //  fetchData();
  }, []);
 const submitForm = useCallback(async () => {
    if (editing) {
      await updateLicense(editing.id, form);
      setToast({ open: true, message: 'Licencja zaktualizowana', severity: 'success' });
    } else {
      await createLicense(form);
      setToast({ open: true, message: 'Licencja utworzona', severity: 'success' });
    }
    setOpen(false);
    fetchData();
  }, [editing, form]);

  const submitFormGenere = useCallback(async () => {
  //  if (editing) {
     // await updateLicense(editing.id, form);
   //   setToast({ open: true, message: 'Wygenerowano klucze', severity: 'success' });
  //  } else {
      await createKeyList(formGenere);
      setToast({ open: true, message: 'Wygenerowano klucze', severity: 'success' });
   // }
    setOpenGenere(false);
  fetchDataLicenseGenerated();
  }, [formGenere]);

   const submitFormGenereExport = useCallback(async () => {

      const data = await getExportList(formGenereExport);
       const headers = ['Gotowy link','Hash', 'Klucz', 'Data'];
       if (!data.data || data.data.length === 0){
              setToast({ open: true, message: 'Brak kluczy do eksportu', severity: 'warning' });

       }
       else{

       
       const rows = data.data.map(l => [
        `https://hshop.pl/order/${l.secret}/${l.keyHash}`,
        l.keyHash ?? "-",
        l.keyValue ?? "-",
        l.keyDate ?? "-"]);
    const csvContent = [headers, ...rows].map(e => e.join(';')).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, data.name+'.csv');
      setToast({ open: true, message: 'Weksportowano dane do pliku', severity: 'success' });
       }
   // }
    setopenExport(false);
    fetchDataLicenseGenerated();
  }, [formGenereExport]);


   const onCreate = useCallback(() => {
      setEditing(null);
      setForm({  client_email:"", shop_name:"", nip: "", shop_phone: "" });
      setOpen(true);
    }, []);


   const onCreatenewKayTest = useCallback(() => {
      setEditingKeyGenere(null);
      setFormGenere ({  keyType:"prod", keyCount:"20" });
      setOpenGenere(true);
    }, []);
    const fetchNeedFV = async () => {
  try {
    const res = await fetch("https://hs2api.razamit.pl/needFV", {
      credentials: "include",
      method: "POST",
    });
    const data = await res.json();
    setOptions((prev) => ({ ...prev, needFV: data }));
 
    console.log(data);
  } catch (err) {
    console.error(err);
  }
};

 const onExportKeys = useCallback(() => {
      setFormGenereExport ({  exportType:"test", exportTypestatus:"notused"});
      setopenExport(true);
    }, []);

 const clearDatabase = useCallback(async () => {
        const data = await ClearDatabasePOST();
        setToast({ open: true, message: data.message, severity: data.status });
        fetchDataLicenseGenerated();
    }, []);



    const onNeedFvDialog = useCallback(() => {
      fetchNeedFV();
      setOpenFV(true);
    }, []);
  const onDelete = useCallback(async (id) => {
    const dd = await deleteLicense(id);
    setToast({ open: true, message: dd.data.message, severity: 'success' });
    fetchData();
  }, []);




  const columns = useMemo(() => ([
    {
      field: 'client',
      headerName: 'Stan',
      width:20,
     
      renderCell: (params) => {
        const row = params.row;
    
        return (
          <div className="flex items-center justify-center">
            {row.login_data !== "" ? (
       <svg className="w-8 h-8" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
   
{row.user_want_use==="0" ?(
    <circle cx="16" cy="16" r="10" fill="none" stroke="#ef4444" strokeWidth="2" opacity="0.8">
              <animate 
                attributeName="r" 
                values="8;13;10" 
                dur="0.5s" 
                repeatCount="indefinite" 
              />
              <animate 
                attributeName="opacity" 
                values="0.8;0.2;0.8" 
                dur="1.5s" 
                repeatCount="indefinite" 
              />
            </circle>
):('')}
   
     
            <circle cx="16" cy="16" r="10" fill="#22c55e" />
            
            {/* Biały checkmark */}
            <path 
              d="M11 17l3 3 7-7" 
              stroke="white" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
            />
          </svg>

            ) : (
              <svg
              className="w-6 h-6 text-red-100"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              {/* czerwone wypełnione kółko */}
              <circle cx="12" cy="12" r="10" fill="currentColor" />
            
              {/* biały minus w środku */}
              <line
                x1="8"
                y1="12"
                x2="16"
                y2="12"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </svg>
            
            )}
          </div>
        );
      }
    },  
    {
      field: 'client',
      headerName: 'Klient',
     
      renderCell: (params) => {
        const row = params.row;
        return (
         
          <div className="flex flex-col relative">
             {row.user_want_use==="0" ?( <svg
      className="absolute -top-2 -right-2 w-5 h-5 text-red-500 animate-pulse"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1 21h22L12 2 1 21z" />
      <text
        x="12"
        y="17"
        textAnchor="middle"
        fontSize="12"
        fill="white"
        fontWeight="bold"
      >
        !
      </text>
    </svg>):('')}
<span
  className={`flex-1 font-semibold text-xs flex items-center gap-1 ${
    row.counttofv == 1
      ? "text-gray-900"
      : "text-amber-500 drop-shadow-sm"
  }`}
>
  {row.counttofv != 1 && (
    <span className="text-amber-400 text-sm">
      👑
    </span>
  )}

  {row.shop_name}
</span>      

        <span className="text-gray-400 text-xs">{row.client_email}</span>
          </div>
        );
      }
    },
     {
      field: 'Dystrybutor',
      headerName: 'Dystrybutor',
      
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex flex-col">
            <span className="font-medium text-gray-900 text-xs">{row.CompnyName}</span>
            <span className="text-gray-400 text-xs">{row.accountManager}</span>
          </div>
        );
      }
    },
  {
      field: 'license_name',
      headerName: 'Licencja',
     
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex flex-col">
            {row.license_number==""?(
             <span className="font-light text-gray-300">Brak licencji</span>
            )
             :(
                          <span className="font-medium text-gray-900">{row.license_number}</span>


             )}
            <span className="text-gray-400 text-xs ">{row.license_name}</span>
          </div>
        );
      }
    },
    {
      field: 'license_spyradar',
      headerName: 'SpyRadar',
     
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="">

            {row.wantBrandly==="1"?(
             <SpyRadarIco onClick={() => detailsConcurentPAnelDIalog(row)}  className="relative"  />
            )
             :(
                        <span className="font-light text-gray-300">Brak</span>

             )}
          </div>
        );
      }
    },
 
    {
      field: 'dates',
      headerName: 'Terminy',
    
      renderCell: (params) => {
        const row = params.row;
        let expire = '-';
        let lastLogin = '-';
        try {
         
          if (row.newAcount === "1" || row.newAcount === 1)
          {
            expire = "-";
          }
          else{
            expire = format(parseISO(String(row.shop_expireDate)), 'yyyy-MM-dd', { locale: pl });

          }
          if (row.last_login)
            lastLogin = format(parseISO(String(row.last_login)), 'yyyy-MM-dd', { locale: pl });
        } catch {}
    
        return (
<div className="flex flex-col gap-1 text-gray-700 whitespace-nowrap w-full">
  <div className="flex flex-row justify-between w-full">
    <span className="text-gray-500">Wygasa:</span>
    <span className="font-medium text-gray-900"> {expire}</span>
  </div>

  <div className="flex flex-row justify-between w-full">
    <span className="text-gray-500 text-md">Ost. log.:</span>
    <span className="font-medium text-gray-900"> {lastLogin}</span>
  </div>
</div>
        );
      }
    },
    {
    
        field: 'status', headerName: 'Status', width:90, sortable: false,
        renderCell: (params) => {
            let needFV = params.row.needFV;
        let fvliczone = params.row.counttofv;
        let needFvTagedToExport = params.row.needFvTagedToExport;
   
        return (
          <div>
            <div className="flex flex-col gap-1 text-gray-700 whitespace-nowrap w-full">
  <div className="flex flex-row justify-between w-full">
    <span className="text-gray-500 text-xs">Status:</span>
    <LicenseStatusChip date={params.row.shop_expireDate} isNewAcount={params.row.newAcount} />
  </div>

  <div className="flex flex-row justify-between ">
    <span className="text-gray-500 text-xs">Faktura:</span>
      <div className="flex flex-row justify-between">

{needFvTagedToExport === "1" ?
  <div className="flex items-center justify-center">
      <BsHourglass className="w-4 h-4 animate-spin" />
      <span className="ml-2 text-gray-500">Księgowanie</span>
    </div> : <FvStatusChip counter={needFV} testTag={params.row.licenseId} isAddedToFv={fvliczone} />}

  </div>
  </div>
</div>
       
   
         
  
    
    


        </div>
        );
     
    }},
//      {
//       field: 'dates',
//       headerName: 'Faktury',
    
//       renderCell: (params) => {
       
//         let needFV = params.row.needFV;
//         let fvliczone = params.row.counttofv;
//         let needFvTagedToExport = params.row.needFvTagedToExport;
//         let lastLogin = '-';
//         try {
         
//           if (params.row.newAcount === "1" || params.row.newAcount === 1)
//           {
         
//           }
//           else{
         

//           }
       
//         } catch {}
    
//         return (

//   <div className="flex flex-row justify-between w-full">

// {needFvTagedToExport === "1" ?
//   <div className="flex items-center justify-center">
//       <BsHourglass className="w-4 h-4 animate-spin" />
//       <span className="ml-2 text-gray-500">Księgowanie</span>
//     </div> : <FvStatusChip counter={needFV} testTag={params.row.licenseId} isAddedToFv={fvliczone} />}

//   </div>

//         );
//       }
//     },
    {
      field: 'actions', headerName: 'Akcje',width:50, sortable: false, renderCell: (params) => (
        <div className="flex gap-2">
        <RowActions changesubscriberLicensefvOrNot={changesubscriberLicefvOrNot} logedUser={logedUser}  row={params.row} renvewSubscription={renvewSubscription} disableSubscription={disableSubscription} onAcceptPrzetwarzanie={onAcceptPrzetwarzanie} onSendLicense={onSendLicense} onEdit={onEdit} onSendOneMoreTime={onSendOneMoreTime} onRefresh={onRefresh} onSendEmail={onSendEmail} editParserAccess={onEditParserAccess} editAditionalModules={onEditAdititionalModules}  onDelete={onDelete} onChangeConcurentPlatforms={onChangeConcurentPlatforms} />
      </div>
      
      )
    }
  ]), [onEdit, changesubscriberLicefvOrNot]);
const columnsTest = useMemo(() => ([
   
 {
  field: 'status',
  headerName: 'Typ klucza',
  renderCell: (params) => {
    const row = params.row;
    const isTest = row.isTest === "1";

    return (
      <div className="flex items-center gap-2">
        
        {/* Ikona */}
        {isTest ? (
          <BsPatchQuestion  className="text-gray-200 text-lg" />
        ) : (
          <BsShieldCheck className="text-green-600 text-lg" />
        )}

        {/* Tag */}
        <span
          className={
           `px-2 py-1 rounded text-xs font-normal text-gray-900 `
          }
        >
          {isTest ? "Testowy" : "Produkcyjny"}
        </span>

      </div>
    );
  }
},
{
  field: 'exportstate',
  headerName: 'Stan eksportu',
  renderCell: (params) => {
    const row = params.row;
    const isExport = row.isExport === "1";

    return (
      <div className="flex items-center gap-2">

        {/* Ikona */}
        {isExport ? (
          <BsCloudUpload className="text-yellow-600 text-lg" />
        ) : (
          <BsCloud className="text-green-600 text-lg" />
        )}

        {/* Tag */}
        <span
          className={
            `px-2 py-1 rounded text-xs font-normal text-gray-900 `
          
          }
        >
          {isExport ? "Użyty" : "Oczekuje"}
        </span>

      </div>
    );
  }
},
    {
      field: 'Distributor',
      headerName: 'Dystrybutor',
     
      renderCell: (params) => {
        const row = params.row;
        return (
         
          <div className="flex flex-col">
        
            <span className="font-medium text-gray-900">{row.dystributor}</span>
          </div>
        );
      }
    },
     {
      field: 'keyHash',
      headerName: 'Hash',
      
      renderCell: (params) => {
        const row = params.row;
        return (
          <div className="flex flex-col">
            <span className="text-gray-400">{row.keyHash}</span>
          </div>
        );
      }
    },
  {
      field: 'date',
      headerName: 'Wygenerowano',
     
      renderCell: (params) => {
        const row = params.row;
        let  date = format(parseISO(String(row.keyDate)), 'yyyy-MM-dd', { locale: pl });
        return (
          <div className="flex flex-col">
          
                          <span className="font-medium text-gray-900">{date}</span>


          
          </div>
        );
      }
    },
     {
      
          field: 'actions', headerName: 'Akcje',width:50, sortable: false, 
          
          renderCell: (params) => {
             const row = params.row;
              const isTest = row.isTest === "1";
            return (<div className="flex gap-2">
                {isTest ? (
              <Button size='vsmall' variant='outlined' color='primary' className='flex items-center justify-center gap-2'  onClick={()=>openLinkCallback(params.row)}><BsLink className='w-4 h-4 '></BsLink>Link</Button>
        ) : (''
        )}
                 
    
          </div>)
          }
        }
 
  ]), [onEdit]);

    const filterRowsNeedFV = useMemo(() => {

    const isNeedFV = rows.filter(l => l.needFV === "1");
    return isNeedFV;
    
  }, [rows]);
  const filteredRows = useMemo(() => {
    const term = q.trim().toLowerCase();
    return rows.filter(l => {
      const byTerm = !term || l.shop_name.toLowerCase().includes(term);
      const avail = (l.seats || 0) - (l.assigned || 0);

      const parsed = new Date(String(l.shop_expireDate).replace(' ', 'T'));
      const expired = parsed < new Date();

      const byLicenseIsRuning =
        licenseIsRuning === 'all' ||
        (licenseIsRuning === 'runing' && !expired) ||
        (licenseIsRuning === 'stop' && expired);

        const byIsActivate =
          isActivate === 'all' ||
          (isActivate === 'activate' && l.login_data ) ||
          (isActivate === 'noactivate' && !l.login_data );
       


        const byIsSend =
          isLicenseSend === 'all' ||
          (isLicenseSend === 'send' && l.newAcount !=="1" ) ||
          (isLicenseSend ==='notsend' && l.newAcount ==="1" );


          const byFVStatus =
          fvStatus === 'all' ||
          (fvStatus === 'zal' && l.needFV === "2") ||
          (fvStatus === 'zap' && l.needFV === "0") ||
          (fvStatus === 'niezap' && l.needFV === "1");

      const byAvabyLicensType =
        licenseType === 'all' ||
        (licenseType ===  l.licenseId);

        const byVendorType=   vendorType === 'all' ||
        (vendorType ===  l.vendorId);
      return byTerm && byAvabyLicensType && byLicenseIsRuning && byIsActivate && byIsSend && byFVStatus && byVendorType;
    });
  }, [rows, q, licenseType, licenseIsRuning, isActivate, isLicenseSend, fvStatus, vendorType]);

  const filteredRowsTest = useMemo(() => {
    const term = q.trim().toLowerCase();
    return rows.filter(l => {
      const byTerm = !term || l.shop_name.toLowerCase().includes(term);
      const avail = (l.seats || 0) - (l.assigned || 0);

      const parsed = new Date(String(l.shop_expireDate).replace(' ', 'T'));
      const expired = parsed < new Date();

      const byLicenseIsRuning =
        licenseIsRuning === 'all' ||
        (licenseIsRuning === 'runing' && !expired) ||
        (licenseIsRuning === 'stop' && expired);

        const byIsActivate =
          isActivate === 'all' ||
          (isActivate === 'activate' && l.login_data ) ||
          (isActivate === 'noactivate' && !l.login_data );
       


        const byIsSend =
          isLicenseSend === 'all' ||
          (isLicenseSend === 'send' && l.newAcount !=="1" ) ||
          (isLicenseSend ==='notsend' && l.newAcount ==="1" );


          const byFVStatus =
          fvStatus === 'all' ||
          (fvStatus === 'zal' && l.needFV === "2") ||
          (fvStatus === 'zap' && l.needFV === "0") ||
          (fvStatus === 'niezap' && l.needFV === "1");

      const byAvabyLicensType =
        licenseType === 'all' ||
        (licenseType ===  l.licenseId);

        const byVendorType=   vendorType === 'all' ||
        (vendorType ===  l.vendorId);
      return byTerm && byAvabyLicensType && byLicenseIsRuning && byIsActivate && byIsSend && byFVStatus && byVendorType;
    });
  }, [rows, q, licenseType, licenseIsRuning, isActivate, isLicenseSend, fvStatus, vendorType]);





  const totalLicenses = rows.length;
  const totalNewAccounts = rows.filter(l => String(l.newAcount) === "1").length;
  const totalAssigned = rows.reduce((acc, l) => acc + (l.assigned || 0), 0);
  //const utilization = totalSeats > 0 ? Math.round((totalAssigned / totalSeats) * 100) : 0;
  const expiredCount = rows.filter(l => l.shop_expireDate && new Date(l.shop_expireDate) < new Date()).length;

const needFV = rows.reduce((acc, l) => acc + (l.needFV == 1 && l.licenseId !== "10" && l.counttofv ==1 ? 1 : 0), 0);
const rezygnacja = rows.reduce((acc, l) => acc + (l.user_want_use == "0" ? 1 : 0), 0);

  const today = new Date();

  const wygasle = rows.filter(l => {
    if (!l.shop_expireDate) return false;
    const exp = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    return exp < today;
  }).length;
  
 
  // licencje aktywne
  const aktywne = rows.filter(l => {
    if (!l.shop_expireDate) return false;
    const exp = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    return exp >= today;
  }).length;
  return (
    <div>
      {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") ? 
             (
               <PageHeaderPortal
        title="Licencje"
        subtitle={`Zarządzanie licencjami i okresem życia aplikacji.`}
         
        actions={
        <Button className="h-fit self-end sm:w-auto " variant="contained" size="medium" onClick={onCreate} >Dodaj licencję</Button>
      }
      />
             ):(
               <PageHeaderPortal
        title="Licencje"
        subtitle={`Zarządzanie licencjami i okresem życia aplikacji.`}
      />
             )}
     


   <Tabs
      tabs={[
        {
          id: "tab1",
          label: "Produkcyjne",
          icon: <BsShieldCheck size={16}/>,
            onClick: () => {
             
              fetchData();
              setSelectedTab("p");
            },
       
          content: (
           <div>
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 gap-2 sm:gap-5 mb-2 sm:mb-5">
        <StatCard label="Liczba licencji" value={totalLicenses}  />
        <StatCard label="Nie wysłano" value={totalNewAccounts}  />
        <StatCard label="Wygasło" value={wygasle}  />
        <StatCard label="Rezygnacja" value={rezygnacja}  />
        <StatCard label="Aktywne" value={aktywne}  />
      </div>

      <div className="w-full rounded-sm bg-white p-3 sm:p-2 lg:p-5 border border-gray-200 mb-3 sm:mb-4">
        <div className=" flex-row gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div className="flex flex-col gap-2">
          <Input label="Szukaj" value={q} onChange={e => setQ(e.target.value)} size="small" className="w-full mb-2 text-xs" fullWidth placeholder="Nazwa licencji..." />
          </div>
          <div className="grid grid-cols-2 md:grid-cols-7 gap-2 sm:gap-3 w-full sm:max-w-full">
            <Select label="Stan" 
            value={isActivate} 
            onChange={e => setisActivate(e.target.value)} 
            size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'activate', label: 'Aktywowano' },
              { value: 'noactivate', label: 'Brak aktywacji' }
            ]} />
             {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") ? 
             
             ( 
             <>
             
             <Select
           
            label="Rodzaj licencji"
            value={licenseType}
            size='small'
            onChange={(e) => setlicenseType (e.target.value )}
            fullWidth
            options={[
              { value: 'all', label: 'Wszystkie' },
              ...options.licensesList.map(c => ({
                value: c.id,
                label: c.license_name + ' - ' + c.license_price+' zł',
              })),
            ]}
          />
  <Select
           
           label="Dystrybutor"
           value={vendorType}
           size='small'
           onChange={(e) => setvendorType(e.target.value )}
           fullWidth
           options={[
             { value: 'all', label: 'Wszystkie' },
             ...options.vendorList.map(c => ({
               value: c.id,
               label: c.CompnyName ,
             })),
           ]}
         />
         </>
):('')}
           

             <Select label="Status" value={licenseIsRuning} onChange={e => setLicenseIsRuning(e.target.value)} size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'runing', label: 'Aktywne' },
              { value: 'stop', label: 'Wygasły' }
            ]} />
            <Select label="Licencja wysłana" 
            value={isLicenseSend} 
            onChange={e => setisLicenseSend(e.target.value)} 
            size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'send', label: 'Wysłana' },
              { value: 'notsend', label: 'Oczekuje' }
            ]} />
 <Select label="Faktura" 
            value={fvStatus} 
            onChange={e => setFVStatus(e.target.value)} 
            size="small" fullWidth options={[
              { value: 'all', label: 'Wszystkie' },
              { value: 'zal', label: 'Założone' },
              { value: 'zap', label: 'Zapłacone' },
              { value: 'niezap', label: 'Nie zapłacone' },
            ]} />

            <Button className="h-fit self-end sm:w-auto " variant="outlined" size="small" onClick={() => { setQ('');setisActivate('all');setLicenseIsRuning('all'); setlicenseType('all'); setvendorType('all') }}>Wyczyść</Button>
            

          </div>
          <div className="flex gap-2">
          </div>
        </div>
      </div>

      {expiredCount > 10000000 && (
        <Alert severity="warning" className="mb-3 sm:mb-4">
          Uwaga: {expiredCount} licencj{expiredCount === 1 ? 'a' : expiredCount < 5 ? 'e' : 'i'} wygasł{expiredCount === 1 ? 'a' : expiredCount < 5 ? 'y' : 'o'}.
        </Alert>
      )}  {needFV > 0 && (
        <Alert severity="info" className="mb-3 sm:mb-4">
          <div className="flex flex-row items-center justify-between w-full">
  <p className="text-sm text-gray-700">
    Uwaga: Konieczność wystawienia faktur.
  </p>

  <Button
    variant="outlined"
    size="small"
    onClick={onNeedFvDialog}
    className="ml-4"
  >
    Zobacz
  </Button>
</div>
        </Alert>
      )}

      <div className="rounded-sm overflow-hidden ">
        <Table 
          columns={columns} 
          data={filteredRows} 
          loading={loading}
        />

      </div>
      </div>
          )
        },
        {
           id: "tab2",
          label:"Testowe",
           icon: <BsTable  size={16} />,

             onClick: () => {
             
              fetchDataLicenseGeneratedTest();
              setSelectedTab("t");
            },
         // onClick:fetchDataLicenseGeneratedTest,
          content: (
            <div>
      <div className="flex flex-col border border-gray-200 rounded-sm sm:flex-row gap-3 mb-2 text-xs justify-start sticky top-[98px] bg-white p-2">

 <p className="text-xs text-gray-500 m-3">
  <span className="font-bold text-primary-600 mr-2">
 UWAGA!
  </span>
  Licencje testowe nie uprawniają do logowania w aplikacji. Dają możliwość przetestowania mechanizmu generowania oraz zamawiania licencji przez klienta. Pozwalają również zalogować się na stronie hshop.pl w celu weryfikacji przesyłanych danych.
 </p>

</div>
            <Table 
              columns={columns}
              data={rowsTestLicenses}
              loading={loading}
            />
            </div>
          
          )
        },
        {
          id: "tab3",
          label: "Klucze",
          align: "right",
           icon: <BsKey size={16} />,
          onClick:fetchDataLicenseGenerated,
          content: (
            <div>

            <div className="sticky top-[120px] bg-white border border-gray-200 rounded-md p-2 z-10 mb-2">
  {/* Górna część: legenda + ważne info */}
  <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
    
    {/* Legenda */}


    {/* Ważne info */}
    <p className="text-sm text-gray-500 text-center md:text-left">
      <span className="font-bold text-yellow-600 mr-1">WAŻNE!</span>
      Wygenerowane klucze nie są automatycznie pełnoprawnymi licencjami. Są konwertowane na licencje z chwilą aktywacji w panelu przez klienta. Dotyczy to kluczy testowych oraz produkcyjnych.
    </p>
  </div>

<div className="flex flex-col md:flex-row md:items-center md:justify-between w-full mt-2">

  {/* LEGENDA — zawsze po lewej */}
  <div className="flex flex-wrap justify-center md:justify-start items-center gap-6 text-xs">
    <div className="flex items-center gap-2">
      <BsPatchQuestion className="text-gray-400" />
      <span className="text-gray-700">Testowy</span>
    </div>
    <div className="flex items-center gap-2">
      <BsShieldCheck className="text-green-600" />
      <span className="text-gray-700">Produkcyjny</span>
    </div>
    <div className="flex items-center gap-2">
      <BsCloudUpload className="text-yellow-600" />
      <span className="text-gray-700">Użyty</span>
    </div>
    <div className="flex items-center gap-2">
      <BsCloud className="text-green-600" />
      <span className="text-gray-700">Oczekuje</span>
    </div>
  </div>


  {/* PRZYCISKI — mobile pod sobą, desktop po prawej */}
  <div className="flex flex-row items-center gap-3 mt-4 md:mt-0 md:justify-end">

    <button
      onClick={onCreatenewKayTest}
      className="flex items-center gap-2 !text-xs md:text-sm px-2 md:px-4 py-2 text-gray-700 border border-gray-200 rounded hover:border-primary-500 transition"
    >
      <BsKey className="w-4 h-4 hidden sm:block"/>
      Wygeneruj
    </button>

    <button
      onClick={onExportKeys}
      className="flex items-center gap-2 !text-xs md:text-sm px-2 md:px-4 py-2 text-gray-700 border border-gray-200 rounded hover:border-primary-500 transition"
    >
      <BsCloudDownload className="w-4 h-4 hidden sm:block" />
      Eksport
    </button>

    <button
      onClick={() =>
        requestConfirm(
          `Czy na pewno chcesz wyczyścić dane w bazie. Wszystkie wygenerowane klucze zostaną usunięte. Jeśli wpisałeś klucze do swojego systemu one również przestaną działać`,
          () => clearDatabase()
        )
      }
      className="flex items-center gap-2 !text-xs md:text-sm px-2 md:px-4 py-2 text-primary-700 border border-gray-200 rounded hover:border-primary-500 transition"
    >
      <BsTrash2 className="w-4 h-4 hidden sm:block" />
      Wyczyść
    </button>

  </div>

</div>


</div>
            <Table 
              columns={columnsTest}
              data={rowsGenerated}
              loading={loading}
            />
            </div>
          )
        }
      ]}
    />
    <Dialog open={open} onClose={() => setOpen(false)} width="w-[500px]">
              <DialogTitle>{editing ? 'Edycja licencji' : 'Nowa licencja'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                
                <div className="grid grid-cols-2 gap-2">
                <Input size='small' label="Firma" value={form.shop_name} placeholder='Wprowadź nazwę firmy' onChange={e => setForm(v => ({ ...v, shop_name: e.target.value }))} fullWidth />
                <Input size='small' label="NIP" value={form.nip} placeholder='Wprowadź NIP' onChange={e => setForm(v => ({ ...v, nip: e.target.value }))} fullWidth />
                </div>
                <div className="grid grid-cols-2 gap-2">
                <Input size='small' label="Email" value={form.client_email} placeholder='Wprowadź adres email' onChange={e => setForm(v => ({ ...v, client_email: e.target.value }))} fullWidth />
                <Input size='small' label="Telefon kontaktowy" value={form.shop_phone} placeholder='Wprowadź numer kontaktowy' onChange={e => setForm(v => ({ ...v, shop_phone: e.target.value }))} fullWidth />
                </div>
                <Input size='small' className="hidden" value={form.licDays||""} placeholder='Wprowadź numer kontaktowy' onChange={e => setForm(v => ({ ...v, licDays: e.target.value }))} fullWidth />
                <Input size='small'   className="hidden"  value={form.userID||""} placeholder='Wprowadź numer kontaktowy' onChange={e => setForm(v => ({ ...v, userID: e.target.value }))} fullWidth />

     <Select
        label="Licencja"
        value={form.licenseId ||''}
        onChange={(e) =>{
          const selectedId = e.target.value;
          const selectedLicense = options.licensesList.find(c => c.id === selectedId);
           setForm(v => (
          
          { ...v, 
            licenseId: selectedId ,
             licDays: selectedLicense ? selectedLicense.days : '',
             userID: user.userId
          }))}
        }
         
        fullWidth

        options={[
          ...options.licensesList.map(c => ({
            value: c.id,
            label: c.license_name + ' - ' + c.license_price+' zł',
          })),
        ]}
      /> 
                </div>
              </DialogContent>
              <DialogActions>
                <Button size='medium' onClick={() => setOpen(false)} variant="outlined">Anuluj</Button>
                <Button size='medium' onClick={submitForm} variant="contained" color='success'>Zapisz</Button>
              </DialogActions>
            </Dialog>

       <Dialog open={OpenGenere} onClose={() => setOpenGenere(false)} width="w-[250px]">
              <DialogTitle>{editingKeyGenere ? 'Edycja klucza' : 'Wygeneruj klucze'}</DialogTitle>
              <DialogContent>
                <div className="space-y-4 mt-2">
                <Input size='small' type='number' className='text-xs font-normal text-gray-400' label="Liczba licencji" value={formGenere.keyCount} placeholder='Wprowadź liczbę kluczy' onChange={e => setFormGenere(v => ({ ...v, keyCount: e.target.value }))} fullWidth />
    <Select label="Rodzaj kluczy" value={formGenere.keyType || ''} 
    onChange={(e) => {
      setFormGenere(v => ({
      ...v,
      keyType: e.target.value,
    }));
  }}
  fullWidth
  options={[
    { value: "test", label: "Klucze testowe" },
    { value: "prod", label: "Klucze produkcyjne" },

  ]}
/>
                </div>
              </DialogContent>
              <DialogActions>
                <Button size='small' onClick={() => setOpenGenere(false)} variant="outlined">Anuluj</Button>
                <Button size='small' onClick={submitFormGenere} variant="contained" color='success'>Zapisz</Button>
              </DialogActions>
            </Dialog>
        <Dialog open={openExport} onClose={() => setopenExport(false)} width="w-[400px]">
              <DialogTitle>Które klucze wyeksportować ?</DialogTitle>
             <DialogContent>
  <div className="space-y-6 mt-2">

    {/* Sekcja 1 */}
    <div>
      <p className="text-sm font-medium text-gray-700">
        Rodzaj kluczy
      </p>
        <p className="text-xs text-gray-400 font-normal mb-2"> Wybierz rodzaj klucza do esportu.</p>
      

      <div className="flex flex-col sm:flex-row gap-4">
        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="radio"
            name="exportType"
            value="test"
            checked={formGenereExport.exportType === "test"}
            onChange={(e) =>
              setFormGenereExport(v => ({ ...v, exportType: e.target.value }))
            }
            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">
            klucze testowe
          </span>
        </label>

        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="radio"
            name="exportType"
            value="prod"
            checked={formGenereExport.exportType === "prod"}
            onChange={(e) =>
              setFormGenereExport(v => ({ ...v, exportType: e.target.value }))
            }
            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">
            klucze produkcyjne
          </span>
        </label>
      </div>
    </div>

    {/* Sekcja 2 */}
    <div>
      <p className="text-sm font-medium text-gray-700 mb-2">
        Stan klucza
      </p>
        <p className="text-xs text-gray-400 font-normal mb-2">Wybierz stan klucza do esportu. WAŻNE: wybranie opcji gotowy do eksportu oznaczy podane klucze jako wyeksportowane.</p>

      <div className="flex flex-col sm:flex-row gap-4">
        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="radio"
            name="exportTypestatus"
            value="notused"
            checked={formGenereExport.exportTypestatus === "notused"}
            onChange={(e) =>
              setFormGenereExport(v => ({ ...v, exportTypestatus: e.target.value }))
            }
            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">
            gotowy do eksportu
          </span>
        </label>

        <label className="flex items-center gap-2 cursor-pointer group">
          <input
            type="radio"
            name="exportTypestatus"
            value="used"
            checked={formGenereExport.exportTypestatus === "used"}
            onChange={(e) =>
              setFormGenereExport(v => ({ ...v, exportTypestatus: e.target.value }))
            }
            className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 group-hover:text-gray-900">
            już wyeksportowany
          </span>
        </label>
      </div>
    </div>

  </div>
</DialogContent>

              <DialogActions>
                <Button size='small' onClick={() => setopenExport(false)} variant="outlined">Anuluj</Button>
                <Button size='small' onClick={submitFormGenereExport} variant="contained" color='success'>Eksportuj</Button>
              </DialogActions>
            </Dialog>
      
          
          <LicensesFVDialog width="lg" open={openFV} setOpen={setOpenFV} licensesList={options.needFV} runCheckRPT={runCheckRPT}    />
          <SuppliersDialog openSuppliersDialog={openSuppliersDialog} setOpenSuppliersDialog={setOpenSuppliersDialog} suppliersList={options.integracje} selectedSuppliers={form.supplierId} onSave={handleSaveSupliersIntegration} />
          <AditionalModuleDialog openAditionalModuleDialog={openAditionalModuleDialog} setOpenAditionalModuleDialog={setOpenAditionalModuleDialog} suppliersList={options.aditionalModuleData} selectedModules={form.access_ids} onSave={handleSaveAditionalModules} />
          <ConcurentPlatformsDialog openConcurentPlatformsDialog={openConcurentPlatformsDialog} setOpenConcurentPlatformsDialog={setOpenConcurentPlatformsDialog} suppliersList={options.concurentPlatformsData} selectedPlatforms={form.concurent_platforms} onSave={handleSaveConcurentPlatforms} />
                   <SpyRadarDetailsUser openAditionalModuleDialog={openCompetitionListDialog} setOpenAditionalModuleDialog={setOpenCompetitionListDialog} spyRadarLicense={details} />


                <Snackbar open={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} className="shadow-lg">
                 
                </Snackbar>
                <AnimatePresence>
  {showRptTag && (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.4 }}
      className="fixed bottom-4 right-4 flex flex-col items-end z-50"
    >
      {/* Karty z liczbą rozliczeń */}
      <motion.div
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={() => setExpandRptTag(prev => !prev)}
        className="relative cursor-pointer group"
      >

        <div className="absolute -top-1 -right-1 w-10 h-6 bg-primary-200 rounded-sm shadow-sm rotate-9 group-hover:rotate-12 transition-transform"></div>
        <div className="absolute -top-1 -right-2 w-10 h-6 bg-primary-300 rounded-sm shadow-md rotate-3 group-hover:rotate-6 transition-transform"></div>
        <div className="relative w-10 h-6 bg-white border border-slate-200 rounded-sm shadow-lg flex items-center justify-center">
        <span className="text-xs text-gray-500">RPT</span>
        
          {options.rptList?.length > 0 && (
            <div className="absolute -top-2 -right-2 bg-primary-500 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-md">
              {options.rptList.length}
            </div>
          )}
        </div>
      </motion.div>

      {/* Tooltip wysuwany zamiast znikać */}
      <motion.div
        initial={{ opacity: 0, y: 10, height: 0 }}
        animate={
          expandRptTag
            ? { opacity: 1, y: 0, height: "auto" }
            : { opacity: 0, y: 10, height: 0 }
        }
        transition={{ duration: 0.3 }}
        className={`overflow-hidden mt-3 bg-white border border-gray-200 rounded-lg shadow-lg p-3 text-sm text-gray-700 w-70 origin-bottom`}
      >
        <p className="font-semibold mb-1">Lista RPT</p>
        <div className="max-h-45 overflow-y-auto">
          {options.rptList?.slice(0, 50).map((r, i) => (
              <div className="flex flex-row items-center mb-1" key={i}>
                  <p className="w-60 text-xs text-gray-600 border-b border-slate-100 py-1 hover:bg-slate-50 cursor-pointer rounded">
                            {r.name || `${r.RPT_number}`}
 
             
            </p>
                <Button variant="contained" color="success" size="small" className='ml-2' 
                onClick={() => {
              requestConfirm(
                `Kasuje liste RPT oraz oznacza faktury jako opłacone. Dla wersji demonstracyjnej funkcjonalnośc jest ograniczona. Można bezpiecznie zamknać okno.`,
                () => {
                //  onRefresh(row);
                 // setOpen(false);
                }
              );
            }}

                ><BsCheck></BsCheck></Button>
                <Button variant="outlined" size="small" className='ml-2'
                
                   onClick={() => {
              requestConfirm(
                `Usuniecie listy RPT. Nie powoduje żadnej akcji. Jeśli lista zotawnie usunięta pozostaje rozliczenie użytkownika ręcnia z poziomu tabeli. Można bezpiecznie zamknać okno.`,
                () => {
                //  onRefresh(row);
                 // setOpen(false);
                }
              );
            }}><BsFillTrash3Fill ></BsFillTrash3Fill ></Button>
              </div>
          
          ))}
        </div>
        {options.rptList?.length > 50 && (
          <p className="text-xs text-slate-400 mt-2 text-right">
            +{options.rptList.length - 5} więcej...
          </p>
        )}
      </motion.div>
    </motion.div>
  )}
</AnimatePresence>

          <TestKeysSpecialLinkDialog   open={openLink}
  setOpen={setOpenLink}
  link={link}
  />      
    </div>
 
  );
}
